import { Link } from "react-router-dom";
import { Checkbox } from "@/components/ui/checkbox";
import { useTranslation } from "@/hooks/useTranslation";

export default function ConsentAgreement({
  id,
  checked,
  onCheckedChange,
  isDark,
  testId,
  privacyTitle,
  checkboxClassName,
  smsNotice,
}) {
  const { t } = useTranslation();
  const linkCls = isDark
    ? "text-blue-400 hover:text-blue-300 underline underline-offset-2"
    : "text-red-600 hover:text-red-700 underline underline-offset-2";
  const privacyLabel = privacyTitle || t("consent.privacyPolicyTitle");
  const smsProgramNotice = smsNotice ?? t("consent.smsProgramNotice");

  return (
    <div className={`flex items-start gap-4 p-4 border ${isDark ? "bg-black/30 border-white/5" : "bg-gray-50 border-gray-200"}`}>
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
        className={checkboxClassName}
        data-testid={testId}
      />
      <label
        htmlFor={id}
        className={`text-sm leading-relaxed cursor-pointer ${isDark ? "text-gray-300" : "text-gray-700"}`}
        data-testid="sms-program-notice"
      >
        {smsProgramNotice}{" "}
        <Link
          to="/privacy"
          target="_blank"
          rel="noopener noreferrer"
          className={linkCls}
          onClick={(e) => e.stopPropagation()}
        >
          {privacyLabel}
        </Link>
        .
      </label>
    </div>
  );
}
